import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Vendors
import cookies from "../cookies/cookies";
import httpStatusUtils from "../http-status/http-status.utils";
// Constants
import apiClientConstants from "../../constants/api-client";
import constants from "./constants/api-client.constants";
import storageConstants from "../../constants/storage";
// Configurations
import { doRefreshTokenAction, getInitHeaders } from "./configurations/api.configurations";
// Utils
import { buildFetchUrl, parseResponseBody } from "./helpers/api.helpers";
import sessionUtils from "../session/session.utils";
// Types

var HTTP_STATUS_401_FOUND = false;
var getFetchRequestArguments = function getFetchRequestArguments(_ref) {
  var body = _ref.body,
    channel = _ref.channel,
    _ref$customHeaders = _ref.customHeaders,
    customHeaders = _ref$customHeaders === void 0 ? {} : _ref$customHeaders,
    hasCommonHeaders = _ref.hasCommonHeaders,
    language = _ref.language,
    method = _ref.method,
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params,
    url = _ref.url;
  var headers = hasCommonHeaders ? getInitHeaders({
    channel: channel,
    customHeaders: customHeaders,
    language: language
  }) : _objectSpread({}, customHeaders);
  if (headers['Content-Type'] === 'multipart/form-data') {
    delete headers['Content-Type'];
  }
  if (url !== null && url !== void 0 && url.includes('refresh-token') && cookies.getCookie(storageConstants.COOKIES_IDS.AGENT_TOKEN)) {
    headers[storageConstants.COOKIES_IDS.ACCESS_TOKEN] = cookies.getCookie(storageConstants.COOKIES_IDS.AGENT_TOKEN);
  }
  var init = _objectSpread(_objectSpread({}, constants.INIT_FETCH_CONFIG), {}, {
    method: method,
    headers: headers
  });
  if (method !== constants.METHODS.GET) init.body = JSON.stringify(params);
  if (body) init.body = body;
  return init;
};
var cleanSessionAndRedirect = function cleanSessionAndRedirect() {
  sessionUtils.clearSessionData();
  // if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
  //   window.location.replace('/');
  // } else {
  //   return constants.DEFAULT_ERROR_RESPONSE;
  // }
  return constants.DEFAULT_REFRESH_ERROR_RESPONSE;
};
var refreshTokenService = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref2) {
    var channel, response;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          channel = _ref2.channel;
          _context.n = 1;
          return doRefreshTokenAction(channel)();
        case 1:
          response = _context.v;
          response && localStorage.setItem('tokenRefreshed', 'true');
          return _context.a(2, response || constants.DEFAULT_REFRESH_ERROR_RESPONSE);
      }
    }, _callee);
  }));
  return function refreshTokenService(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var buildCallService = function buildCallService(method) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(props) {
      var absoluteUrl, body, _props$channel, channel, customHeaders, endpoint, _props$hasCommonHeade, hasCommonHeaders, language, params, pathParams, queryParams, url, fetchBody, fetchRequest, request, response, refreshResponse, refreshUrl, refreshFetchBody, fetchRefreshRequest, refreshRequest, _refreshResponse, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            absoluteUrl = props.absoluteUrl, body = props.body, _props$channel = props.channel, channel = _props$channel === void 0 ? apiClientConstants.CHANNELS.WEB : _props$channel, customHeaders = props.customHeaders, endpoint = props.endpoint, _props$hasCommonHeade = props.hasCommonHeaders, hasCommonHeaders = _props$hasCommonHeade === void 0 ? true : _props$hasCommonHeade, language = props.language, params = props.params, pathParams = props.pathParams, queryParams = props.queryParams;
            url = buildFetchUrl({
              absoluteUrl: absoluteUrl,
              endpoint: endpoint,
              pathParams: pathParams,
              queryParams: queryParams
            }), fetchBody = getFetchRequestArguments({
              body: body,
              channel: channel,
              customHeaders: customHeaders,
              hasCommonHeaders: hasCommonHeaders,
              language: language,
              method: method,
              params: params,
              url: url
            }), fetchRequest = function fetchRequest() {
              return fetch(url, fetchBody);
            };
            _context2.p = 1;
            _context2.n = 2;
            return fetchRequest();
          case 2:
            request = _context2.v;
            _context2.n = 3;
            return parseResponseBody(request);
          case 3:
            response = _context2.v;
            if (!(
            // Is candidate to refresh
            httpStatusUtils.isUnauthorizedStatus(request === null || request === void 0 ? void 0 : request.status) && !HTTP_STATUS_401_FOUND && cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN) && localStorage.getItem(storageConstants.LOCALSTORAGE_IDS.USERNAME) && cookies.getCookie(storageConstants.COOKIES_IDS.REFRESH_TOKEN))) {
              _context2.n = 9;
              break;
            }
            HTTP_STATUS_401_FOUND = true;
            _context2.n = 4;
            return refreshTokenService({
              channel: channel,
              method: method,
              props: props,
              request: request
            });
          case 4:
            refreshResponse = _context2.v;
            if (!refreshResponse) {
              _context2.n = 7;
              break;
            }
            refreshUrl = buildFetchUrl({
              absoluteUrl: absoluteUrl,
              endpoint: endpoint,
              pathParams: pathParams,
              queryParams: queryParams
            }), refreshFetchBody = getFetchRequestArguments({
              body: body,
              channel: channel,
              customHeaders: customHeaders,
              hasCommonHeaders: hasCommonHeaders,
              language: language,
              method: method,
              params: params,
              url: url
            }), fetchRefreshRequest = function fetchRefreshRequest() {
              return fetch(refreshUrl, refreshFetchBody);
            };
            _context2.n = 5;
            return fetchRefreshRequest();
          case 5:
            refreshRequest = _context2.v;
            _context2.n = 6;
            return parseResponseBody(refreshRequest);
          case 6:
            _refreshResponse = _context2.v;
            HTTP_STATUS_401_FOUND = false;
            return _context2.a(2, [_refreshResponse, refreshRequest]);
          case 7:
            cleanSessionAndRedirect();
          case 8:
            _context2.n = 10;
            break;
          case 9:
            localStorage.setItem('lastApiCall', String(new Date()));
            // Return everything excepting 401 with accesstoken and refresh token
            HTTP_STATUS_401_FOUND = false;
            return _context2.a(2, [response, request]);
          case 10:
            _context2.n = 12;
            break;
          case 11:
            _context2.p = 11;
            _t = _context2.v;
            HTTP_STATUS_401_FOUND = false;
            //cleanSessionAndRedirect();
            return _context2.a(2, constants.DEFAULT_ERROR_RESPONSE);
          case 12:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 11]]);
    }));
    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var methods = {
  get: buildCallService(constants.METHODS.GET),
  patch: buildCallService(constants.METHODS.PATCH),
  post: buildCallService(constants.METHODS.POST),
  put: buildCallService(constants.METHODS.PUT),
  "delete": buildCallService(constants.METHODS.DELETE)
};
export default methods;